import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("circle", {
  class: "n-loading-circle__background",
  cx: "25",
  cy: "25",
  r: "22"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  class: "n-loading-circle__content",
  cx: "25",
  cy: "25",
  r: "22"
}, null, -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(_ctx.cssClass),
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_3, 2))
}